import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledContactUs = styled.svg<IconProps>`
  & .cls-1 {
    fill: var(--du-color-white);
  }

  & .cls-2 {
    fill: var(--du-color-grey);
  }

  & .cls-3 {
    stroke-linejoin: round;
    stroke-width: 1.5px;
    fill: #fff;
    stroke: var(--du-color-grey);
  }

  & .cls-4 {
    fill: #fff;
    stroke: var(--du-color-grey);
  }

  & .cls-5 {
    filter: url(#Ellipse_3);
  }

  &.hover:hover,
  &.active {
    .cls-1,
    .cls-3 {
      fill: var(--du-color-primary);
    }

    .cls-2 {
      fill: var(--du-color-grey-pale);
    }

    .cls-3,
    .cls-4 {
      stroke: var(--du-color-grey-pale);
    }

    .cls-3 {
      stroke-linejoin: round;
      stroke-width: 1.5px;
    }

    .cls-4 {
      fill: none;
    }
  }
`;

const ContactUsIconLarge: React.FC<IconProps> = ({ active }) => {
  let activeclass = active ? 'active' : undefined;
  const isTouch = !!('ontouchstart' in window) || window.navigator.maxTouchPoints > 0;
  activeclass = `${activeclass} ${!isTouch ? 'hover' : ''}`;
  return (
    <StyledContactUs
      id='Contact-Us-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='54'
      height='54'
      viewBox='0 0 54 54'
      className={activeclass}
    >
      <circle id='Ellipse_3' data-name='Ellipse 3' className='cls-1' cx='27' cy='27' r='27' />
      <g id='mail' transform='translate(14.167 18.844)'>
        <path
          id='Vector'
          className='cls-2'
          d='M23.449,19.106H.868A.869.869,0,0,1,0,18.238V.868A.869.869,0,0,1,.868,0H23.449a.869.869,0,0,1,.868.868v17.37A.869.869,0,0,1,23.449,19.106ZM1.812,2.9h0L1.951,3l0,14.147H22.363V3.007l-9.276,7.206a1.518,1.518,0,0,1-1.864,0L1.954,3.007Zm.46-1.843h0l.217.168.944.735,8.726,6.781,8.724-6.781,1.164-.9,1.065,1.37-.749.583.752-.583L22.048,1.053l-1.161.9-17.452,0-.946-.735-.217-.169Zm0,0L1.2,2.421l.608.474h0l-.606-.472Z'
          transform='translate(0.675 3.28)'
        />
        <path
          id='Path_15966'
          data-name='Path 15966'
          className='cls-3'
          d='M17.031,19.342,25.674,26l8.884-6.658V7.093H17.031Z'
          transform='translate(-12.927 -13.167)'
        />
        <line id='Line_398' data-name='Line 398' className='cls-4' x2='11.791' transform='translate(6.972 -1.667)' />
        <line id='Line_399' data-name='Line 399' className='cls-4' x2='9.07' transform='translate(6.972 1.333)' />
        <line id='Line_400' data-name='Line 400' className='cls-4' x2='7.361' transform='translate(6.972 4.333)' />
      </g>
    </StyledContactUs>
  );
};

export default ContactUsIconLarge;
